import React, { useContext, useEffect } from "react";
import { Routes, useLocation, useNavigate } from "react-router-dom";
import renderRoutes from "../routes/utlis/renderRoutes";
import { AuthContext } from "../context/authContext";
import entryRoutes from "../routes/entry";
import BISnackBar from "../components/Notification/snackbar";
import colaboratorsRoutes from "../routes/colaboratorRoutes";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import BIModal from "../components/Notification/dialog";
import NavigationBar from "../components/common/NavigationBar";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../context/redux/reducers/snackbar";
import { setDialog } from "../context/redux/reducers/dialog";
import useInactivityLogout from "../utils/useInactivityLogout";
import SessionClosedNotification from "../components/Notification/SessionClosedNotification";

import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

export default function Providers() {
  const { idCliente, logout, login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const logOut = () => {
    logout();
    fetch(`${process.env.REACT_APP_BE_URL}/auth/logout`, {
      credentials: "include",
    });
  };

  // Función que maneja el logout automático por inactividad
  const handleInactivityLogout = async () => {
    showSessionClosedNotification();
  };

  // Función que muestra la notificación de sesión cerrada
  const showSessionClosedNotification = () => {
    dispatch(
      setDialog(
        true,
        "sm",
        "Sesión Cerrada por Inactividad",
        <SessionClosedNotification
          dispatch={dispatch}
          setDialog={setDialog}
          logOut={logOut}
          navigate={navigate}
        />,
        "body"
      )
    );
  };

  const getInactivityTimeout = () => {
    const isDevelopment = process.env.NODE_ENV === "development";
    return parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT_MINUTES) || 15;
  };

  const inactivityTimeoutMinutes = getInactivityTimeout();

  const { resetTimer } = useInactivityLogout(
    idCliente ? handleInactivityLogout : null,
    idCliente ? showSessionClosedNotification : null,
    inactivityTimeoutMinutes
  );

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BE_URL}/auth/verify/me`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.result && res.result !== "Ya verificado") {
          dispatch(setSnackbar(true, "success", "Bienvenido"));
          login(res.result);
          navigate("/");
        }
      })
      .catch((err) => {
        dispatch(
          setSnackbar(
            true,
            "warning",
            "Inicia sesión para continuar",
            <WarningAmberOutlinedIcon />
          )
        );
      });
  }, []);

  return (
    <>
      <BISnackBar />
      <BIModal />

      {idCliente && (
        <div>
          <Header variant="colaborator" />
          <Routes>{renderRoutes(colaboratorsRoutes)}</Routes>
          <Footer />
          <NavigationBar />
        </div>
      )}

      {!idCliente && <Routes>{renderRoutes(entryRoutes)}</Routes>}
    </>
  );
}
